import { graphql, useStaticQuery } from "gatsby";

export const useExploreInDelhiQuery = () => {
  const { allStrapiExploreInDelhi } = useStaticQuery(graphql`
    query ExploreInDelhi {
      allStrapiExploreInDelhi {
        nodes {
          banner_section {
            desktop_bg {
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, formats: [WEBP])
                }
              }
            }
            mobile_bg {
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, formats: [WEBP])
                }
              }
            }
            heading
            text_color
            description {
              data {
                description
              }
            }
          }
          near_the_airport {
            heading
            heading_color
            description {
              data {
                description
              }
            }
            cards {
              card_image {
                alternativeText
                url
                localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, formats: [WEBP])
                }
              }
              }
              heading
              heading_color
              description {
                data {
                  description
                }
              }
              card_bg_color
            }
          }
          delhi_attractions {
            table_description {
              data {
                table_description
              }
            }
            description_color
            table_head {
              bg_color
              title
              title_color
            }
            table_body {
              body_content {
                text_desc {
                  data {
                    text_desc
                  }
                }
              }
            }
          }
          short_layovers {
            heading
            heading_color
            description {
              data {
                description
              }
            }
            cards {
              card_bg_color
              card_image {
                alternativeText
                url
                localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, formats: [WEBP])
                }
              }
              }
              heading
              heading_color
              description {
                data {
                  description
                }
              }
            }
          }
          travel_tips_section {
            heading
            heading_color
            description {
              data {
                description
              }
            }
            cards {
              card_bg_color
              card_image {
                alternativeText
                url
                localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: NONE, formats: [WEBP])
                }
              }
              }
              heading
              heading_color
              description {
                data {
                  description
                }
              }
            }
          }
          bottom_text {
            data {
              bottom_text
            }
          }
          bottom_text_bg
        }
      }
    }
  `);
  return allStrapiExploreInDelhi?.nodes[0];
};
